import {GlobalActor, GlobalWatch} from '@acng/frontend-relativity';
import {noop, undefined} from '@acng/frontend-bounty/std/value.js';
import {
  createMap as createIndex,
  clear as clearIndex,
  get as getFromIndex,
  set as setIndex,
} from '@acng/frontend-bounty/collection.js';
import {each, clear as clearList} from '@acng/frontend-bounty/std/array.js';
import {each as eachState} from '@acng/frontend-bounty/object.js';
/**
 * @import {Amateur} from '../../amateurPool/model/amateur.js';
 */
import {ctxEventBusUser} from '../../userPool/context/event-bus-user.js';
import {authUser} from '../../userPool/context/auth-user.js';
import {ctxFriendship} from '../context/friendships.js';
import {POSSIBLE_STATES, STATE_RESET, FRIENDSHIP} from '../../model';
import {getList} from './http.js';
import {listenFriendshipEvent} from './event-bus.js';

/**
 * @type {Readonly<Record<POSSIBLE_STATES[number], Amateur["id"][]>>}
 */
const amateurIdListByState = POSSIBLE_STATES.reduce(
  (res, cur) => ((res[cur] = []), res),
  /** @type {Record<POSSIBLE_STATES[number], Amateur["id"][]>} */ ({})
);

/**
 * @type {Map<Amateur["id"], POSSIBLE_STATES[number] | undefined>}
 */
const stateByAmateurId = createIndex();

/**
 * Put a friendship update into the {@link amateurIdListByState} and {@link stateWithAmateurId}
 *
 * @param {Valid<FRIENDSHIP>} friendship
 */
const put = (friendship) => {
  //DEBUG: if (VERBOSE) console.debug(MODULE, 'put', {friend});

  const {
    partner: {id: amateurId},
    status,
  } = friendship;

  setIndex(stateByAmateurId, amateurId, status);

  each(POSSIBLE_STATES, (s) => {
    const list = amateurIdListByState[s];
    const i = list.indexOf(amateurId);

    if (s == status) {
      if (i < 0) {
        list.unshift(amateurId);
      }
    } else if (i >= 0) {
      list.splice(i, 1);
    }
  });
};

/**
 * @param {Amateur} amateur
 * @returns {POSSIBLE_STATES[number]} the friendship state
 */
export const get = (amateur) => getFromIndex(stateByAmateurId, amateur.id) ?? STATE_RESET;

/**
 * @param {POSSIBLE_STATES[number]} type
 * @returns {Array<Amateur["id"]>}
 */
export const list = (type) => amateurIdListByState[type];

/**
 * @type {Promise<void> | undefined}
 */
let futureList;
let removeListener = noop;

const watch = GlobalWatch(ctxEventBusUser);
const broadcast = GlobalActor(ctxFriendship);

export const setup = async () => {
  if (futureList) {
    try {
      await futureList;

      return;
    } catch (reason) {}
  }

  watch((currentUser, previous) => {
    if (currentUser?.id != previous?.id) {
      eachState(amateurIdListByState, clearList);
      clearIndex(stateByAmateurId);
      futureList = undefined;
      broadcast(null);
    }

    removeListener();

    if (!currentUser) {
      return;
    }

    removeListener = listenFriendshipEvent((friendship) => {
      put(friendship);
      broadcast(friendship);
    });

    futureList = (async () => {
      const list = await getList(document.documentElement);

      if (currentUser.id == authUser?.id) {
        // && isConnected(element)) {
        each(list, put);
        broadcast(null);
      }
    })();
  });

  await futureList;
};
